export default "__VITE_ASSET__BUJjRltC__"